const firebaseConfig = {
    apiKey: "AIzaSyBH0FO46BeeiNereHzqTeDE4WKonmJKLkY",
    authDomain: "transport-for-dhaka-mkm.firebaseapp.com",
    projectId: "transport-for-dhaka-mkm",
    storageBucket: "transport-for-dhaka-mkm.appspot.com",
    messagingSenderId: "707475934128",
    appId: "1:707475934128:web:23a382ea8467a503026475"
  };

  export default firebaseConfig;